import style from '@/fsd/shared/ui/static/css/commonStyle.module.scss';
import cx from 'classnames';
import React from 'react';
import headerStyles from './HeaderTable.module.scss';

export const HeaderTable = (props) => {
  const { items, className, additionalClass = '', fixed = false } = props;

  return (
    <div
      className={cx(
        className,
        style.headerTable,
        headerStyles[additionalClass],
        style[`lineItems-${items}`],
        {
          [headerStyles.fixedHeader]: fixed,
        }
      )}
      data-testid={props.dataTestid}
    >
      {props.children}
    </div>
  );
};

export default HeaderTable;
